import script from "./TranslateComponent.vue?vue&type=script&lang=js"
export * from "./TranslateComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__